import React from "react";
import styles from "./Profile.module.scss";
//import {ReactComponent as CalendarIcon2} from "../../../../assets/svg/calendar.svg";
import Arrow from "../../../../assets/img/arrow_r_small.png";
import Rating from "@material-ui/lab/Rating";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import StarBorderRoundedIcon from "@material-ui/icons/StarBorderRounded";
import { ReactComponent as CalendarIcon } from "./../../../../assets/svg/calendar.svg";
import Slide from "@material-ui/core/Slide";
import Fade from "@material-ui/core/Fade";
import LawyerCard from "../../../Shared/LawyerCard/LawyerCard";
import { ReactComponent as CameraIcon } from "./../../../../assets/svg/camera.svg";

class Profile extends React.Component<any, any> {
  constructor(props) {
    super(props);

    this.state = {
      experience: null,
    };
  }
  componentDidMount() {
    this.props.lawyer.domains.find((cur) => {
      if (cur.id === this.props.domain) {
        this.setState({
          experience: cur.experience,
        });
      }
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.lawyer.id != this.props.lawyer.id)
      this.props.lawyer.domains.find((cur) => {
        if (cur.id === this.props.domain) {
          this.setState({
            experience: cur.experience,
          });
        }
      });
  }

  render() {
    const { lawyer, domainName, opinions, services, price } = this.props;
    const { experience } = this.state;

    let opinionText = "opinii";
    if (opinions) {
      if (opinions.totalOpinionVerified === 1) opinionText = "opinia";
      else if (opinions.totalOpinionVerified < 5) opinionText = "opinie";
    }

    return (
      <Fade in={true} timeout={800}>
        <div className={styles.Profile}>
          <div className={styles.lawyerCard}>
            <LawyerCard lawyer={lawyer} imageUrl={this.props.imageUrl} />
          </div>

          {lawyer.description && (
            <div className={styles.info}>
              <h3 className={styles.title}>O mnie</h3>
              <div className={styles.about}>{lawyer.description}</div>
            </div>
          )}

          {experience && (
            <div className={styles.info}>
              <h3 className={styles.title}>Doświadczenia {domainName}</h3>
              <div className={styles.about}>{experience}</div>
            </div>
          )}

          {lawyer.education && (
            <div className={styles.info}>
              <h3 className={styles.title}>Edukacja</h3>
              <div className={styles.about}>{lawyer.education}</div>
            </div>
          )}

          <hr />
          <div className={styles.opinionInfo}>
            <div className={styles.left}>
              <Rating
                name="star-rating"
                value={opinions.average}
                precision={0.5}
                className={styles.stars}
                readOnly
                size="small"
                icon={<StarRoundedIcon />}
                emptyIcon={<StarBorderRoundedIcon />}
              />
              <div className={styles.text}>Ogólna ocena</div>
            </div>

            <span className={styles.count} onClick={this.props.toggleOpinions}>
              {opinions ? opinions.opinions.totalOpinionVerified : 0}{" "}
              {opinionText} <img src={Arrow} alt="Arrow" />
            </span>
          </div>
          <hr />
          <div className={styles.opinionInfo}>
            <div className={styles.left}>
              <CameraIcon width="20px" />
              <div className={styles.text}>
                Konsultacja online: {price ? price + " zł" : "--"}
              </div>
            </div>

            <span className={styles.count} onClick={this.props.togglePriceList}>
              Cennik <img src={Arrow} alt="Arrow" />
            </span>
          </div>
        </div>
      </Fade>
    );
  }
}

// const Profile = () => (
//   <div className={styles.Profile}>
//     Profile Component<br/>
//       <button onClick={this.props.toggleProfile}>Click Here To Call Playlist-list Function</button>
//   </div>
// );

Profile.defaultProps = {};

export default Profile;
